import { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

const statutColors = {
  en_attente: "#fb8c00",
  confirmee: "#43a047",
  refusee: "#e53935",
  archivee: "#757575",
};

const statutLabels = {
  en_attente: "En attente",
  confirmee: "Confirmée",
  refusee: "Refusée",
  archivee: "Archivée",
};

function Calendrier() {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  const fetchReservations = async () => {
    try {
      const res = await api.get("/reservations");
      const evts = res.data
        .filter((r) => r.statut !== "refusee" && r.statut !== "archivee")
        .map((r) => ({
          id: String(r.id),
          title: `${r.directeur_ville} — ${r.groupe_nom}`,
          date: r.date.slice(0, 10),
          backgroundColor: statutColors[r.statut],
          borderColor: statutColors[r.statut],
          extendedProps: { reservation: r },
        }));
      setEvents(evts);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, []);

  const handleEventClick = (info) => {
    setSelected(info.event.extendedProps.reservation);
    setOpen(true);
  };

  const Row = ({ label, value }) =>
    value ? (
      <MDTypography variant="body2">
        <strong>{label} :</strong> {value}
      </MDTypography>
    ) : null;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card sx={{ p: 3 }}>
          <MDBox mb={2} display="flex" alignItems="center" gap={2}>
            <MDTypography variant="h6">Calendrier des réservations</MDTypography>
            <MDBox display="flex" gap={1}>
              <Chip
                size="small"
                label="En attente"
                sx={{ bgcolor: "#fb8c00", color: "white" }}
              />
              <Chip
                size="small"
                label="Confirmée"
                sx={{ bgcolor: "#43a047", color: "white" }}
              />
            </MDBox>
          </MDBox>
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            locale="fr"
            firstDay={1}
            events={events}
            eventClick={handleEventClick}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,dayGridWeek",
            }}
            buttonText={{
              today: "Aujourd'hui",
              month: "Mois",
              week: "Semaine",
            }}
            eventDisplay="block"
            height="auto"
          />
        </Card>
      </MDBox>

      {/* Dialog détail réservation */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <span>Détail de la réservation</span>
            {selected && (
              <Chip
                label={statutLabels[selected.statut]}
                sx={{
                  bgcolor: statutColors[selected.statut],
                  color: "white",
                }}
                size="small"
              />
            )}
          </MDBox>
        </DialogTitle>
        <DialogContent>
          {selected && (
            <MDBox display="flex" flexDirection="column" gap={1}>
              <Row label="Directeur" value={selected.directeur_nom} />
              <Row label="Ville" value={selected.directeur_ville} />
              <Divider />
              <Row label="Groupe demandé" value={selected.groupe_nom} />
              {selected.groupe_affecte_nom && (
                <MDTypography variant="body2" sx={{ color: "#2e7d32" }}>
                  <strong>Groupe affecté :</strong> {selected.groupe_affecte_nom}
                </MDTypography>
              )}
              <Row label="Occasion" value={selected.occasion} />
              <Row
                label="Date"
                value={selected.date.slice(0, 10).split("-").reverse().join("/")}
              />
              <Row label="Heure" value={selected.heure?.slice(0, 5)} />
              <Row label="Lieu" value={selected.lieu} />
              <Row label="Nombre de personnes" value={selected.nb_personnes} />
              {selected.responsable_fete && (
                <>
                  <Divider />
                  <Row label="Responsable" value={selected.responsable_fete} />
                </>
              )}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpen(false)} color="info">
            Fermer
          </MDButton>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default Calendrier;
